import React, { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { getCityList } from "../../../redux/slices/activity";
import { useSelector } from "react-redux";
import { dispatch } from "../../../redux/store";
import Box from "@mui/material/Box";

const CarPickupLocation = ({ setCityValue, cityValue, cityQuery }) => {
  const { cityListRes } = useSelector((state) => state.activity);
  const [cityList, setCityList] = useState([]);
  const handleAutocompleteChange = (event, value) => {
    // Use the retrieved value as needed

    // const filterCode = city.filter((data) => value === data.cityName);
    setCityValue(value);
    // setValue(filterCode[0]?.countryName);
    // 
  };

  useEffect(() => {
    dispatch(getCityList({ search: "" }));
  }, [dispatch]);

  useEffect(() => {
    if (cityListRes) {
      setCityList(cityListRes.responseData);
    }
  }, [cityListRes]);

  return (
    <>
      <Box
        className={`searchMenu-loc lg:px-0 js-form-dd`}
        sx={{
          width: "100%",
          "& label.Mui-focused": {
            color: "black",
          },
          "& .MuiInputBase-input": {
            // height: "16px",
          },
          "& .MuiAutocomplete-clearIndicator": {
            display: "none", // Hides the clear (close) button
          },

          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
          },
          "& .MuiInput-underline:after": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "1px solid rgba(0, 0, 0, 0.5)",
              borderRadius: "8px",
            },
            "&:hover fieldset": {
              border: "1px solid rgba(0, 0, 0, 0.5)",
            },
            "&.Mui-focused fieldset": {
              border: "1px solid rgba(0, 0, 0, 0.5)",
            },
          },
        }}
      >
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          value={cityValue}
          options={cityList.map((data) => data.cityName)}
          onChange={handleAutocompleteChange}
          renderInput={(params) => (
            <TextField {...params} placeholder="Pickup Location" />
          )}
        />
      </Box>
    </>
  );
};

export default CarPickupLocation;
